import { FInter, FlexBox, useToasts, useIsMobile, useBreakpoint } from '@brg/ui';
import { useAuth } from '../../../core/hooks/auth/useAuth';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { useHistory } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { API, Competition, CompetitionAPI, Endpoints, Nullable, Project, UserSignAPI, GetProjectsByFilterProps, ProjectAPI, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { LayoutConst, bTag, useModal } from '../../../core';
import { ActionsTitle, ActionsWrapper, ActionsColumnBlock, ProjectsCount, MainTitle, ActionBottomButtons, ModalContainer, TagsTitle, SendButton, ExamTitle, CreateButton, ExamFooterButtons, DeselectButton, SubmitButton, SelectedProjectName, SelectedProjectWrapper, SelectedProjectDesc } from './styles';
import { Outer } from 'shared/pages/explore/styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import { BTag } from 'core/components';
import { SendProjectModalWrapper } from './employStyles';
import { CompleteSend, NoProjectsCheckbox } from './SendProjectForEmploy';
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BackButton } from 'shared/pages/notfound/styles';
import { CreateLinkTo } from 'shared/constants/linkTo';

const hseDomains:Record<string, string> = { en: process.env.REACT_APP_URL_HSEDESIGN_COM || '', ru: process.env.REACT_APP_URL_HSEDESIGN_RU || ''}


export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const SortingType = styled.div`

`

export const NeedLogin = (props: { competition?: Competition }) => {
  const auth = useAuth();
  const history = useHistory();
  const theme = useTheme();
  return (
  <Outer>
    <FlexBox style={{ flexFlow: "column" }}  offsetTop={24} offsetRight={20} offsetLeft={20}>
      <div style={{ marginBottom: '40px' }}>
        <BackLink onClick={() => history.push('/competition/' + props.competition?.competitionId)}>
          <span>←</span> {props.competition?.name}
        </BackLink>
      </div>
      <ActionsColumnBlock>
        <FInter.TextDiv color={theme.competition.frameMainText}>
          Для того, чтобы отправить работу на участие в конкурсе <b>{props.competition?.name}</b> необходимо войти
        </FInter.TextDiv>
        <FlexBox offsetTop={20}>
          <SendProjectButton onClick={() => auth.login()}>Войти</SendProjectButton>
        </FlexBox>
      </ActionsColumnBlock>
    </FlexBox>
  </Outer>);
};


export const NeedProject = (props: { competition?: Competition }) => {
    const history = useHistory();
    const modal = useModal();

    const { t } = useTranslation();

    const tags:Tag[] = useMemo(
      () => [
        ...(props.competition?.regularTags || []),
        ...(props.competition?.requredTags || []),
        ...(props.competition?.tags || [])] || []
    , [props])

    //@ts-ignore
    const isExam = props.competition?.lmsModuleProjectId;

    const closeModal = () => {
      modal.hide();
    }

    const handleCreateProject = () => {
      const requiredTagId = [...(props.competition?.requredTagIds || [])].pop();
      history.push(!!requiredTagId ? `${CreateLinkTo.projectCreate()}?tagId=${requiredTagId}` : CreateLinkTo.projectCreate());
      modal.hide();
    }

    return <FlexBox width={'100%'} widthMobile={'calc(100% - 32px)'} offsetTop={96} justify='center' align='center' offsetLeftMobile={16} offsetRightMobile={16}>
        <FlexBox direction={'column'} gy={20}>
            <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'center'} align={'center'}>
                {isExam &&  <ExamTitle>Нет соответствующих проектов</ExamTitle>}
                <TagsTitle isExam={isExam}>
                  {t(isExam ? 'competition_edit.dont_have_any_project_exam' : 'competition_edit.dont_have_any_project')}
                </TagsTitle>
                {!!tags?.length && (
                  <BTagsGridNew justify='center' style={isExam ? {width: 'max-content', marginTop: '16px'} : {marginTop: '16px'}}>
                    {tags?.map((i) => {
                      return (
                        <BTag
                            tag={i}
                          educational={i.isEducationTag}
                          isProjectsTag
                          key={i.tagId}
                        >
                          {bTag.title(i)}
                        </BTag>
                      )
                  })}
                 
                  </BTagsGridNew>
                )}
                {isExam && <FlexBox offsetTop={40} gx={24}>
                    <BackButton onClick={closeModal}>Назад</BackButton>
                    <CreateButton onClick={handleCreateProject}>Создать проект</CreateButton>
                  </FlexBox>}
            </FlexBox>
        </FlexBox>
    </FlexBox>
};

interface IProps {
    id: string;
    isPreRegistration?: boolean;
    isAllowParticipants?: boolean;
    isExam?: boolean;
    onApplyClick?: () => void;
    selectedProjectId?: string;
}

export const SendProjectModal: FC<IProps> = ({ id, isPreRegistration, isAllowParticipants, isExam, onApplyClick: onPayApplyClick, selectedProjectId }) => {
  const profile = useProfile();
  const [competition, setCompetition] = useState<Competition>();
  const [competitionId, setCompetitionId] = useState<string>();
  //const [time, setT] = useState(new Date().getTime());
  const { error, info } = useToasts();
  const isMobile = useIsMobile();
  const isNewMobile = useBreakpoint(LayoutConst.screen.s -1 );
  const { i18n, t } = useTranslation();
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [sorting, setSorting] = useState(1);
  const modal = useModal();
  const isGeo = AppTester.isGeograffee();
  const [projects, setProjects] = useState<Project[]>([]);
  const [alreadyProjects, setAlreadyProjects] = useState<string[]>([]);
  const [filterOpt, setFilterOpt] = useState<GetProjectsByFilterProps>();
  const [isSendWithoutProject, setIsSendWithoutProject] = useState(false);
  const [showWithoutProjectsModal, setShowWithoutProjectsModal] = useState(false);
  //const [isLegalsSigned, setLegalsSigned] = useState<boolean>(false);
  const hasCalledOnApplyClick = useRef(false); // Флаг для предотвращения повторных вызовов

  const [{ allowedInfo, allowedStatus }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);

  useEffect(() => {
    if (id) {
        setCompetitionId(id)
    }
  }, [id])

  useEffect(() => {
    if (competitionId) {
        CompetitionAPI.Get({ idCompetition: competitionId })
        .then(v => v.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [i18n.language, competitionId]);


  useEffect(() => {
    projects && getAlreadyProjects(projects);
  }, [projects])


  useEffect(() => {
    if (filterOpt) {
      ProjectAPI.GetList(filterOpt).then((r) => r.json()).then((r) => {
        setProjects(API.toLang(r?.data, i18n.language))
      })
    }
  }, [filterOpt, i18n])

  const isNeedToFill = useMemo(() => {
    return (competition && 
      competition?.nominations &&
      competition?.nominations[0].needToFillForm) ? true : false
  }, [competition]);
  
  const haveProjects = useMemo(() => (projects?.length === 0), [projects]);
  //@ts-ignore
  const isPaidApplication = useMemo(() => competition?.isPaidApplication, [competition]);

  const showNoProjectsRequestCheckbox = useMemo(
    () => (!selectedProjects?.length && isAllowParticipants)
  , [selectedProjects, isAllowParticipants])

  const competitionCreativeOpen = useMemo(() => !!competition?.nominations[0].needToFillForm,[competition])
  const hasDocuments = useMemo(() => (!!competition?.nominations?.[0]?.documentsIds?.length), [competition])

  useEffect(() => {
    if (profile && profile.accountId) {
      UserSignAPI.CheckSignsDocuments({ 
        service: ['competitions'],
        userId: profile.accountId
      })
      .then(d => {
        if (d.status === 200) return d.json(); // список доков
        //if (d.status === 204) setLegalsSigned(false); // у юзера нет неподписанных доков
      })
      .then((d: any) => {
        // //@ts-ignore
        // if (d && competition && competition?.nominations && competition?.nominations[0]?.documentsIds){
        //   //@ts-ignore
        //   const needSign = d.some(x => competition?.nominations[0]?.documentsIds.includes(x));
        //   //setLegalsSigned(needSign);
        //   // d.map((i) => {
        //   //   //@ts-ignore
        //   //   setLegalsSigned(competition?.nominations[0]?.documentsIds.includes(i.documentId))
        //   // })
        // }
      })
    }
  },[profile, competition]);

  const competitionTags: string[] = useMemo(
    () => {
      if (competition) {
        return [
          ...competition?.tags, 
          ...competition?.regularTags, 
          ...competition?.requredTags
        ]
        ?.map((tag) => tag?.tagId) || []
      }

      return [];
    }, [competition])
  const [userPaidCard, setUserPaidCard] = useState(false);
    
   useEffect(() => {
     if(isPaidApplication && competitionId){
       API.request()
             .endpoint(Endpoints.competitions)
             .url('/api/Competition/GetUserCompetitionCards')
             .addQuery('competitionId', competitionId)
             .get()
             .send()
             .then(response => response.json())
             .then(competitionCard => {
               setUserPaidCard(!!competitionCard.length)
             })
             .catch(error => {
               setUserPaidCard(false);
             });
     } else {
       setUserPaidCard(false);
     }
     
   }, [competitionId, isPaidApplication]);

  useEffect(
    () => {
      if (profile && profile.accountId && competitionId && competition) {
        if (!!competitionTags?.length) {
          setFilterOpt({
            authorIds: [profile.accountId],
            projectFilter: sorting,
            isContextIgnored: true,
            projectStatus: [1, 7],
            exceptCompetitionIds: [competitionId],
            onlyAuthors: false,
            tagIds: competitionTags,
          });
        } else {
          setFilterOpt({
            authorIds: [profile.accountId],
            projectFilter: sorting,
            isContextIgnored: true,
            projectStatus: [1, 7],
            exceptCompetitionIds: [competitionId],
            onlyAuthors: false,
            onlyBooks: ' '
          });
        }
      }
    },
    [competitionId, profile, sorting, competitionTags, competition]
  );

  const getAlreadyProjects = useCallback((data: Project[]) => {
    const alreadyList: string[] = [];
    data.forEach((p) => {
      //@ts-ignore
      if  (p?.competitionApproves && (!!p?.competitionApproves?.length || !!p?.pendingCompetitionIds?.length) && competitionId ) {
          //@ts-ignore
        if (!!p.competitionApproves?.find?.(({ competitionId }) => competitionId === competition?.competitionId) || p?.pendingCompetitionIds?.includes(competitionId)) // условие необходимо если проекты смогут быть в разных конкурсах
            alreadyList.push(p?.projectId);
      }
    })
    setAlreadyProjects(alreadyList);
  }, [competitionId])

  const onSendWithoutProjects = useCallback(() => {
    setIsSendWithoutProject(!isSendWithoutProject);
}, [isSendWithoutProject])


  const getLegalsModal = useCallback((flag: boolean, fn: Function) => {
    if (flag && competitionId && competition && competition.nominationsID && competitionCreativeOpen) {
      modal.show(isPreRegistration ? 'competition-custom-legals' : 'competition-legals', {
        projects: selectedProjects,
        nominationIds:[...competition.nominationsID],
        competitionId,
        hasDocuments,
        callback: () => {
          fn(competitionId);
        },
      });
    } else fn(competitionId);   
  }, [competition, modal, competitionId, selectedProjects, hasDocuments, competitionCreativeOpen, isPreRegistration])

  
  const onApplyClick = async (id: string, forceSelectedProjectId?: string) => {
    // Используем переданный selectedProjectId или текущий selectedProjects
    const projectsToUse = forceSelectedProjectId ? [forceSelectedProjectId] : selectedProjects;
    if(!forceSelectedProjectId){
      const res = window.confirm(t(isExam ? 'competition.confirm_msg.send_exam' : 'competition.confirm_msg.send'));
      if (!res) return;
    }

    //@ts-ignore
    if (competition?.maxParticipantsCount && projectsToUse?.length > (allowedStatus?.allowedMax - allowedStatus?.allowedCurrent) ) {
      error(`Вы не можете подать проекты на конкурс, так как модератор установил ограничение на количество. Обратитесь к модератору.`)
      return;
    }
    // проверка дедлайна приемки проектов
    const endDate = new Date(competition?.endDate || 0);
    const now = new Date();
    const isDeprecated = endDate < now
    if (isDeprecated){
      modal.show('competition-sent-error', {
        competitionEndDate: competition?.endDate,
        onClick: () => {
          window.location.reload()
        },
        onClose: () => window.location.reload(),
    });
    return;
    }

      try {
        //Потому что 2 запроса дублируются ф-ционал. ApplyNomination и Apply делают по сути одно и тоже
        //1-й проект отправляется с подтверждением подписания анкеты, а остальные без
        if ((projectsToUse?.length > 1 && isNeedToFill) || !isNeedToFill) {
          const projects = isNeedToFill ? [...projectsToUse]?.slice(1) : projectsToUse;
          if (isExam) {
            await Promise.all(projects.map((value, idx) => {
              API.request()
                  .endpoint(Endpoints.competitions)
                  .url('/api/Competition/ApplyProjectToExam')
                  .post()
                  .addQuery('competitionId', competition?.competitionId || '')
                  .addQuery('ProjectId', value)
                  .send()})
            )
          } else {
            await Promise.all(projects.map((value, idx) => {
              API.request()
                  .endpoint(Endpoints.competitions)
                  .url('/api/Competition/Apply')
                  .post()
                  .addQuery('NominationID', competition?.nominationsID?.length ? competition.nominationsID[0] : '')
                  .addQuery('ProjectID', value)
                  .send()})
            )
          }
        }

          //setT(Date.now());
          // Очищаем selectedProjects только если не используем forceSelectedProjectId
          if (!forceSelectedProjectId) {
            setSelectedProjects([]);
          }

          if (id) {

            if (isExam) {
              info('Проект успешно подан на экзамен')
              return modal.show('competition-sent', {
                  competitionId: id,
                  isExam: isExam,
                  onClick: () => {
                    window.location.href = process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.project(competition?.lmsModuleProjectId)
                  },
                  onClose: () => window.location.href = process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.project(competition?.lmsModuleProjectId),
              });
            }

              modal.show('competition-sent', {
                  competitionId: id,
                  isExam: isExam,
                  onClick: () => {
                    window.location.reload()
                  },
                  onClose: () => window.location.reload(),
              });
          }

      } catch (e) {
        error(String(e));
      }
  };
 
  // Автоматически выбираем проект при возврате от экваиринга
  useEffect(() => {
    if (selectedProjectId && projects.length > 0 && !hasCalledOnApplyClick.current) {
      const projectExists = projects.some(project => project.projectId === selectedProjectId);
      
      if (projectExists && !selectedProjects.includes(selectedProjectId)) {
        setSelectedProjects([selectedProjectId]);
        // Автоматически вызываем onApplyClick если это возврат от экваиринга
        if (onPayApplyClick) {
          hasCalledOnApplyClick.current = true; // Устанавливаем флаг
          setTimeout(() => {
            // Вызываем onApplyClick с актуальным selectedProjectId напрямую
            onApplyClick(competitionId || '', selectedProjectId);
          }, 100);
        }
      }
    }
  }, [selectedProjectId, projects, selectedProjects, onPayApplyClick])
  
  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    //setT(Date.now());
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        sorting={sorting}
        hideRightBar={false}
        hideLeftBar={true}
        hideRightButtons
        onSortingChange={onSortingChange}
        isTagPage={false}
        projectCount={projects?.length}
      />
    ),
    [
      sorting,
      onSortingChange,
      projects, 
    ],
  );

  const handleSendWihoutProject = () => {
    const confirm = window.confirm(`Подать заявку на участие без проекта?`)

    if (confirm) {
      try {
        API.request()
        .endpoint(Endpoints.competitions)
        .url('/api/Competition/RequestParticipantToCompetition')
        .post()
        .addQuery('competitionId', competition?.competitionId || '')
        .send()
        .then((r) => {
          if (r?.status === 200) {
            setShowWithoutProjectsModal(true);
          }
        })
      }
      catch(err) {
        console.error('Что-то пошло не так');
      }
    }
  }

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
  }, [sorting, setSorting]);
  const selectedProjectName = useMemo(() => {
    if (selectedProjects.length === 0) return '';
    const selectedProject = projects.find(p => p.projectId === selectedProjects[0]);
    return selectedProject?.title || '';
  }, [selectedProjects, projects]); 
  const handleDeselectProject = useCallback(() => {
    setSelectedProjects([]);
  }, []);

  const handleSubmitFor = useCallback(() => {   

    modal.show('confirmation', {
      projectName: selectedProjectName,
      competitionId: competitionId,
      competitionPrice: competition?.competitionInfo?.applicationPrice,
      projectId: competition?.lmsModuleProjectId,
      selectedProjectId: selectedProjects[0],
      onConfirm: () => {
        console.log('Переход к оплате за проект:', selectedProjectName);
      },
      onCancel: () => {
        console.log('Отмена отправки');
      },
      onPaymentSuccess: () => {
        console.log('Оплата прошла успешно, проект отправлен на конкурс');
      },
      onPaymentFail: () => {
         modal.show('paymentErrorModal', {
            title: 'Ошибка',
            message: 'Оплата отклонена провайдером',
            returnButtonText: 'Вернуться к модулю'
        });
      }
    });
  }, [selectedProjects, competitionId, selectedProjectName, modal, isNeedToFill, onApplyClick]);
  


  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (alreadyProjects && alreadyProjects.length > 0) {
      return data ? alreadyProjects.includes(data) : false;
    }
  }, [alreadyProjects])

  const noProjectsRequestCheckbox = useMemo(() => (
    <NoProjectsCheckbox text={t('teams.modal.without_projects')} disable={isSendWithoutProject} onClick={onSendWithoutProjects} />
  ), [onSendWithoutProjects, t, isSendWithoutProject ])

  const disableSend = useMemo(
  () => (isAllowParticipants ? (!isSendWithoutProject && selectedProjects?.length === 0) : selectedProjects?.length === 0)
  , [isSendWithoutProject, selectedProjects, isAllowParticipants])

  if (!profile) {
    return <NeedLogin competition={ competition }/>
  }

  return (

    <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      
        <SendProjectModalWrapper directionMobile='column' justify={isMobile ? 'flex-start': 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative'}}>
            <ActionsWrapper hide={showWithoutProjectsModal} direction="column" style={{ justifyContent: 'center', position: 'relative', width: '100%' }}>
                <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' width={'100%'} >
                  <FlexBox direction='column' directionMobile='column'>
                    {!haveProjects && <MainTitle>
                      {isPaidApplication ? t('competition.pay_title') : t('competition.select_project')}
                    </MainTitle>}
                    {isMobile && isAllowParticipants && noProjectsRequestCheckbox}
                  </FlexBox>
                  {!isNewMobile && !haveProjects && !isPaidApplication && (
                    <FlexBox>
                      <SendButton isGreen={isGeo} width={187} disabled={disableSend} onClick={(isSendWithoutProject && selectedProjects?.length === 0) ? () => handleSendWihoutProject() : () => getLegalsModal(isNeedToFill, onApplyClick)}>
                        {t('competition.send')}
                      </SendButton>
                    </FlexBox>
                  )}
                  {isPaidApplication && userPaidCard && (
                    <FlexBox>
                      <SendButton isGreen={isGeo} width={187} disabled={disableSend} onClick={(isSendWithoutProject && selectedProjects?.length === 0) ? () => handleSendWihoutProject() : () => getLegalsModal(isNeedToFill, onApplyClick)}>
                        {t('competition.send')}
                      </SendButton>
                    </FlexBox>
                  )}
                </ActionsTitle>
                {(!haveProjects || isAllowParticipants) && (
                  <FlexBox offsetBottom={20} direction='row' justify='space-between' align='center'>
                    {showNoProjectsRequestCheckbox ? noProjectsRequestCheckbox : (
                      <ProjectsCount>
                          {t('competition.selected_projects', {count: selectedProjects?.length})}
                      </ProjectsCount>
                    )}
                    {
                    isMobile ? 
                    (
                      <MobileFilterSort onClick={onMobileSortingClick}>
                        <SortIcon/>
                        {/* Sort */}
                        <SortingType>{sorting === 1? t('sorting_type.latest') : t('sorting_type.popular')}</SortingType>
                      </MobileFilterSort>
                    ) : 
                    searchBar}
                  </FlexBox>
                )}
                {haveProjects && competition && <NeedProject competition={competition} />}
                {filterOpt && (
                   <ProjectsGridNew k={undefined} isLoading={false}>
                   {projects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                       return (
                          // @ts-ignore
                         <ProjectCardNew
                           project={v as any}
                           isModal={false}
                           withoutGoToProject={true}
                           onProjectClick={modal ?
                             (projectId?: string, e?: any) => {
                               e?.stopPropagation();
                               e?.preventDefault();
                             } : undefined}
                            isSelectable={true}
                           //@ts-ignore
                           isRejected={ProjectDelegate.isRejectedProject(v)}
                           key={(v?.projectId || '') + index}
                           {...computeProject(v)}
                          // isSelectRightNeed={isMobile}
                           metaAlwaysVisible
                           selectRingPosition={RingPositions.right}
                           onSelect={projectId => {
                            setSelectedProjects((prev: string[]) => {
                                if (isExam) return [projectId]
                                if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
                                return [...prev, projectId];
                            });
                            }}
                           selected={selectedProjects?.includes(v?.projectId ?? '')}
                           alreadyProject={isAlreadyProject(v?.projectId)}
                         />
                       );

                   })}
                 </ProjectsGridNew>
                )}
              {isNewMobile && (
                <ActionBottomButtons>
                  <SendButton width={ isNewMobile ? 112 : 187} disabled={selectedProjects?.length === 0} onClick={() => getLegalsModal(isNeedToFill, onApplyClick)}>
                    {t('competition.send')}
                  </SendButton>
                </ActionBottomButtons>
              )}
              {/* Футер с кнопками для экзаменов (lmsModuleProjectId) - показывается только при выборе проекта */}
              {isPaidApplication && !userPaidCard && !isNewMobile && selectedProjects.length > 0 && (
                <ExamFooterButtons>
                  <SelectedProjectWrapper gx={24} justify="space-between" align="center" width="100%">
                    <FlexBox gy={4} direction='column'>
                      <SelectedProjectName>
                        {selectedProjectName} выбран
                      </SelectedProjectName>
                      <SelectedProjectDesc>
                        Вы можете отправить только один проект
                      </SelectedProjectDesc>
                    </FlexBox>
                    <FlexBox gx={24}>
                      <DeselectButton onClick={handleDeselectProject}>Снять выбор</DeselectButton>
                      <SubmitButton onClick={handleSubmitFor}>Отправить</SubmitButton>
                    </FlexBox>
                  </SelectedProjectWrapper>
                </ExamFooterButtons>
              )}
            </ActionsWrapper>
            {showWithoutProjectsModal && <CompleteSend isCompetition title={competition?.name || ''} contextName={''} withoutProjects={true} />}
        </SendProjectModalWrapper>
    </ModalContainer>
  );
};
import { FInter, FlexBox, useToasts, useIsMobile, useBreakpoint } from '@brg/ui';
import { useAuth } from '../../../core/hooks/auth/useAuth';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { useHistory } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { API, Competition, CompetitionAPI, Endpoints, Nullable, Project, UserSignAPI, GetProjectsByFilterProps, ProjectAPI, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { LayoutConst, bTag, useModal } from '../../../core';
import { ActionsTitle, ActionsWrapper, ActionsColumnBlock, ProjectsCount, MainTitle, ActionBottomButtons, ModalContainer, TagsTitle, SendButton, ExamTitle, CreateButton, ExamFooterButtons, DeselectButton, SubmitButton, SelectedProjectName, SelectedProjectWrapper, SelectedProjectDesc } from './styles';
import { Outer } from 'shared/pages/explore/styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import { BTag } from 'core/components';
import { SendProjectModalWrapper } from './employStyles';
import { CompleteSend, NoProjectsCheckbox } from './SendProjectForEmploy';
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BackButton } from 'shared/pages/notfound/styles';
import { CreateLinkTo } from 'shared/constants/linkTo';

const hseDomains:Record<string, string> = { en: process.env.REACT_APP_URL_HSEDESIGN_COM || '', ru: process.env.REACT_APP_URL_HSEDESIGN_RU || ''}


export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const SortingType = styled.div`

`

export const NeedLogin = (props: { competition?: Competition }) => {
  const auth = useAuth();
  const history = useHistory();
  const theme = useTheme();
  return (
  <Outer>
    <FlexBox style={{ flexFlow: "column" }}  offsetTop={24} offsetRight={20} offsetLeft={20}>
      <div style={{ marginBottom: '40px' }}>
        <BackLink onClick={() => history.push('/competition/' + props.competition?.competitionId)}>
          <span>←</span> {props.competition?.name}
        </BackLink>
      </div>
      <ActionsColumnBlock>
        <FInter.TextDiv color={theme.competition.frameMainText}>
          Для того, чтобы отправить работу на участие в конкурсе <b>{props.competition?.name}</b> необходимо войти
        </FInter.TextDiv>
        <FlexBox offsetTop={20}>
          <SendProjectButton onClick={() => auth.login()}>Войти</SendProjectButton>
        </FlexBox>
      </ActionsColumnBlock>
    </FlexBox>
  </Outer>);
};


export const NeedProject = (props: { competition?: Competition }) => {
    const history = useHistory();
    const modal = useModal();

    const { t } = useTranslation();

    const tags:Tag[] = useMemo(
      () => [
        ...(props.competition?.regularTags || []),
        ...(props.competition?.requredTags || []),
        ...(props.competition?.tags || [])] || []
    , [props])

    //@ts-ignore
    const isExam = props.competition?.lmsModuleProjectId;

    const closeModal = () => {
      modal.hide();
    }

    const handleCreateProject = () => {
      const requiredTagId = [...(props.competition?.requredTagIds || [])].pop();
      history.push(!!requiredTagId ? `${CreateLinkTo.projectCreate()}?tagId=${requiredTagId}` : CreateLinkTo.projectCreate());
      modal.hide();
    }

    return <FlexBox width={'100%'} widthMobile={'calc(100% - 32px)'} offsetTop={96} justify='center' align='center' offsetLeftMobile={16} offsetRightMobile={16}>
        <FlexBox direction={'column'} gy={20}>
            <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'center'} align={'center'}>
                {isExam &&  <ExamTitle>Нет соответствующих проектов</ExamTitle>}
                <TagsTitle isExam={isExam}>
                  {t(isExam ? 'competition_edit.dont_have_any_project_exam' : 'competition_edit.dont_have_any_project')}
                </TagsTitle>
                {!!tags?.length && (
                  <BTagsGridNew justify='center' style={isExam ? {width: 'max-content', marginTop: '16px'} : {marginTop: '16px'}}>
                    {tags?.map((i) => {
                      return (
                        <BTag
                            tag={i}
                          educational={i.isEducationTag}
                          isProjectsTag
                          key={i.tagId}
                        >
                          {bTag.title(i)}
                        </BTag>
                      )
                  })}
                 
                  </BTagsGridNew>
                )}
                {isExam && <FlexBox offsetTop={40} gx={24}>
                    <BackButton onClick={closeModal}>Назад</BackButton>
                    <CreateButton onClick={handleCreateProject}>Создать проект</CreateButton>
                  </FlexBox>}
            </FlexBox>
        </FlexBox>
    </FlexBox>
};

interface IProps {
    id: string;
    isPreRegistration?: boolean;
    isAllowParticipants?: boolean;
    isExam?: boolean;
    onApplyClick?: () => void;
    selectedProjectId?: string;
}

export const SendProjectModal: FC<IProps> = ({ id, isPreRegistration, isAllowParticipants, isExam, onApplyClick: onPayApplyClick, selectedProjectId }) => {
  const profile = useProfile();
  const [competition, setCompetition] = useState<Competition>();
  const [competitionId, setCompetitionId] = useState<string>();
  //const [time, setT] = useState(new Date().getTime());
  const { error, info } = useToasts();
  const isMobile = useIsMobile();
  const isNewMobile = useBreakpoint(LayoutConst.screen.s -1 );
  const { i18n, t } = useTranslation();
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [sorting, setSorting] = useState(1);
  const modal = useModal();
  const isGeo = AppTester.isGeograffee();
  const [projects, setProjects] = useState<Project[]>([]);
  const [alreadyProjects, setAlreadyProjects] = useState<string[]>([]);
  const [filterOpt, setFilterOpt] = useState<GetProjectsByFilterProps>();
  const [isSendWithoutProject, setIsSendWithoutProject] = useState(false);
  const [showWithoutProjectsModal, setShowWithoutProjectsModal] = useState(false);
  //const [isLegalsSigned, setLegalsSigned] = useState<boolean>(false);
  const hasCalledOnApplyClick = useRef(false); // Флаг для предотвращения повторных вызовов

  const [{ allowedInfo, allowedStatus }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);

  useEffect(() => {
    if (id) {
        setCompetitionId(id)
    }
  }, [id])

  useEffect(() => {
    if (competitionId) {
        CompetitionAPI.Get({ idCompetition: competitionId })
        .then(v => v.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [i18n.language, competitionId]);


  useEffect(() => {
    projects && getAlreadyProjects(projects);
  }, [projects])


  useEffect(() => {
    if (filterOpt) {
      ProjectAPI.GetList(filterOpt).then((r) => r.json()).then((r) => {
        setProjects(API.toLang(r?.data, i18n.language))
      })
    }
  }, [filterOpt, i18n])

  const isNeedToFill = useMemo(() => {
    return (competition && 
      competition?.nominations &&
      competition?.nominations[0].needToFillForm) ? true : false
  }, [competition]);
  
  const haveProjects = useMemo(() => (projects?.length === 0), [projects]);
  //@ts-ignore
  const isPaidApplication = useMemo(() => competition?.isPaidApplication, [competition]);

  const showNoProjectsRequestCheckbox = useMemo(
    () => (!selectedProjects?.length && isAllowParticipants)
  , [selectedProjects, isAllowParticipants])

  const competitionCreativeOpen = useMemo(() => !!competition?.nominations[0].needToFillForm,[competition])
  const hasDocuments = useMemo(() => (!!competition?.nominations?.[0]?.documentsIds?.length), [competition])

  useEffect(() => {
    if (profile && profile.accountId) {
      UserSignAPI.CheckSignsDocuments({ 
        service: ['competitions'],
        userId: profile.accountId
      })
      .then(d => {
        if (d.status === 200) return d.json(); // список доков
        //if (d.status === 204) setLegalsSigned(false); // у юзера нет неподписанных доков
      })
      .then((d: any) => {
        // //@ts-ignore
        // if (d && competition && competition?.nominations && competition?.nominations[0]?.documentsIds){
        //   //@ts-ignore
        //   const needSign = d.some(x => competition?.nominations[0]?.documentsIds.includes(x));
        //   //setLegalsSigned(needSign);
        //   // d.map((i) => {
        //   //   //@ts-ignore
        //   //   setLegalsSigned(competition?.nominations[0]?.documentsIds.includes(i.documentId))
        //   // })
        // }
      })
    }
  },[profile, competition]);

  const competitionTags: string[] = useMemo(
    () => {
      if (competition) {
        return [
          ...competition?.tags, 
          ...competition?.regularTags, 
          ...competition?.requredTags
        ]
        ?.map((tag) => tag?.tagId) || []
      }

      return [];
    }, [competition])
  const [userPaidCard, setUserPaidCard] = useState(false);
    
   useEffect(() => {
     if(isPaidApplication && competitionId){
       API.request()
             .endpoint(Endpoints.competitions)
             .url('/api/Competition/GetUserCompetitionCards')
             .addQuery('competitionId', competitionId)
             .get()
             .send()
             .then(response => response.json())
             .then(competitionCard => {
               setUserPaidCard(!!competitionCard.length)
             })
             .catch(error => {
               setUserPaidCard(false);
             });
     } else {
       setUserPaidCard(false);
     }
     
   }, [competitionId, isPaidApplication]);

  useEffect(
    () => {
      if (profile && profile.accountId && competitionId && competition) {
        if (!!competitionTags?.length) {
          setFilterOpt({
            authorIds: [profile.accountId],
            projectFilter: sorting,
            isContextIgnored: true,
            projectStatus: [1, 7],
            exceptCompetitionIds: [competitionId],
            onlyAuthors: false,
            tagIds: competitionTags,
          });
        } else {
          setFilterOpt({
            authorIds: [profile.accountId],
            projectFilter: sorting,
            isContextIgnored: true,
            projectStatus: [1, 7],
            exceptCompetitionIds: [competitionId],
            onlyAuthors: false,
            onlyBooks: ' '
          });
        }
      }
    },
    [competitionId, profile, sorting, competitionTags, competition]
  );

  const getAlreadyProjects = useCallback((data: Project[]) => {
    const alreadyList: string[] = [];
    data.forEach((p) => {
      //@ts-ignore
      if  (p?.competitionApproves && (!!p?.competitionApproves?.length || !!p?.pendingCompetitionIds?.length) && competitionId ) {
          //@ts-ignore
        if (!!p.competitionApproves?.find?.(({ competitionId }) => competitionId === competition?.competitionId) || p?.pendingCompetitionIds?.includes(competitionId)) // условие необходимо если проекты смогут быть в разных конкурсах
            alreadyList.push(p?.projectId);
      }
    })
    setAlreadyProjects(alreadyList);
  }, [competitionId])

  const onSendWithoutProjects = useCallback(() => {
    setIsSendWithoutProject(!isSendWithoutProject);
}, [isSendWithoutProject])


  const getLegalsModal = useCallback((flag: boolean, fn: Function) => {
    if (flag && competitionId && competition && competition.nominationsID && competitionCreativeOpen) {
      modal.show(isPreRegistration ? 'competition-custom-legals' : 'competition-legals', {
        projects: selectedProjects,
        nominationIds:[...competition.nominationsID],
        competitionId,
        hasDocuments,
        callback: () => {
          fn(competitionId);
        },
      });
    } else fn(competitionId);   
  }, [competition, modal, competitionId, selectedProjects, hasDocuments, competitionCreativeOpen, isPreRegistration])

  
  const onApplyClick = async (id: string, forceSelectedProjectId?: string) => {
    // Используем переданный selectedProjectId или текущий selectedProjects
    const projectsToUse = forceSelectedProjectId ? [forceSelectedProjectId] : selectedProjects;
    if(!forceSelectedProjectId){
      const res = window.confirm(t(isExam ? 'competition.confirm_msg.send_exam' : 'competition.confirm_msg.send'));
      if (!res) return;
    }

    //@ts-ignore
    if (competition?.maxParticipantsCount && projectsToUse?.length > (allowedStatus?.allowedMax - allowedStatus?.allowedCurrent) ) {
      error(`Вы не можете подать проекты на конкурс, так как модератор установил ограничение на количество. Обратитесь к модератору.`)
      return;
    }
    // проверка дедлайна приемки проектов
    const endDate = new Date(competition?.endDate || 0);
    const now = new Date();
    const isDeprecated = endDate < now
    if (isDeprecated){
      modal.show('competition-sent-error', {
        competitionEndDate: competition?.endDate,
        onClick: () => {
          window.location.reload()
        },
        onClose: () => window.location.reload(),
    });
    return;
    }

      try {
        //Потому что 2 запроса дублируются ф-ционал. ApplyNomination и Apply делают по сути одно и тоже
        //1-й проект отправляется с подтверждением подписания анкеты, а остальные без
        if ((projectsToUse?.length > 1 && isNeedToFill) || !isNeedToFill) {
          const projects = isNeedToFill ? [...projectsToUse]?.slice(1) : projectsToUse;
          if (isExam) {
            await Promise.all(projects.map((value, idx) => {
              API.request()
                  .endpoint(Endpoints.competitions)
                  .url('/api/Competition/ApplyProjectToExam')
                  .post()
                  .addQuery('competitionId', competition?.competitionId || '')
                  .addQuery('ProjectId', value)
                  .send()})
            )
          } else {
            await Promise.all(projects.map((value, idx) => {
              API.request()
                  .endpoint(Endpoints.competitions)
                  .url('/api/Competition/Apply')
                  .post()
                  .addQuery('NominationID', competition?.nominationsID?.length ? competition.nominationsID[0] : '')
                  .addQuery('ProjectID', value)
                  .send()})
            )
          }
        }

          //setT(Date.now());
          // Очищаем selectedProjects только если не используем forceSelectedProjectId
          if (!forceSelectedProjectId) {
            setSelectedProjects([]);
          }

          if (id) {

            if (isExam) {
              info('Проект успешно подан на экзамен')
              return modal.show('competition-sent', {
                  competitionId: id,
                  isExam: isExam,
                  onClick: () => {
                    window.location.href = process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.project(competition?.lmsModuleProjectId)
                  },
                  onClose: () => window.location.href = process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.project(competition?.lmsModuleProjectId),
              });
            }

              modal.show('competition-sent', {
                  competitionId: id,
                  isExam: isExam,
                  onClick: () => {
                    window.location.reload()
                  },
                  onClose: () => window.location.reload(),
              });
          }

      } catch (e) {
        error(String(e));
      }
  };
 
  // Автоматически выбираем проект при возврате от экваиринга
  useEffect(() => {
    if (selectedProjectId && projects.length > 0 && !hasCalledOnApplyClick.current) {
      const projectExists = projects.some(project => project.projectId === selectedProjectId);
      
      if (projectExists && !selectedProjects.includes(selectedProjectId)) {
        setSelectedProjects([selectedProjectId]);
        // Автоматически вызываем onApplyClick если это возврат от экваиринга
        if (onPayApplyClick) {
          hasCalledOnApplyClick.current = true; // Устанавливаем флаг
          setTimeout(() => {
            // Вызываем onApplyClick с актуальным selectedProjectId напрямую
            onApplyClick(competitionId || '', selectedProjectId);
          }, 100);
        }
      }
    }
  }, [selectedProjectId, projects, selectedProjects, onPayApplyClick])
  
  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    //setT(Date.now());
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        sorting={sorting}
        hideRightBar={false}
        hideLeftBar={true}
        hideRightButtons
        onSortingChange={onSortingChange}
        isTagPage={false}
        projectCount={projects?.length}
      />
    ),
    [
      sorting,
      onSortingChange,
      projects, 
    ],
  );

  const handleSendWihoutProject = () => {
    const confirm = window.confirm(`Подать заявку на участие без проекта?`)

    if (confirm) {
      try {
        API.request()
        .endpoint(Endpoints.competitions)
        .url('/api/Competition/RequestParticipantToCompetition')
        .post()
        .addQuery('competitionId', competition?.competitionId || '')
        .send()
        .then((r) => {
          if (r?.status === 200) {
            setShowWithoutProjectsModal(true);
          }
        })
      }
      catch(err) {
        console.error('Что-то пошло не так');
      }
    }
  }

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
  }, [sorting, setSorting]);
  const selectedProjectName = useMemo(() => {
    if (selectedProjects.length === 0) return '';
    const selectedProject = projects.find(p => p.projectId === selectedProjects[0]);
    return selectedProject?.title || '';
  }, [selectedProjects, projects]); 
  const handleDeselectProject = useCallback(() => {
    setSelectedProjects([]);
  }, []);

  const handleSubmitFor = useCallback(() => {   

    modal.show('confirmation', {
      projectName: selectedProjectName,
      competitionId: competitionId,
      competitionPrice: competition?.competitionInfo?.applicationPrice,
      projectId: competition?.lmsModuleProjectId,
      selectedProjectId: selectedProjects[0],
      onConfirm: () => {
        console.log('Переход к оплате за проект:', selectedProjectName);
      },
      onCancel: () => {
        console.log('Отмена отправки');
      },
      onPaymentSuccess: () => {
        console.log('Оплата прошла успешно, проект отправлен на конкурс');
      },
      onPaymentFail: () => {
         modal.show('paymentErrorModal', {
            title: 'Ошибка',
            message: 'Оплата отклонена провайдером',
            returnButtonText: 'Вернуться к модулю'
        });
      }
    });
  }, [selectedProjects, competitionId, selectedProjectName, modal, isNeedToFill, onApplyClick]);
  


  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (alreadyProjects && alreadyProjects.length > 0) {
      return data ? alreadyProjects.includes(data) : false;
    }
  }, [alreadyProjects])

  const noProjectsRequestCheckbox = useMemo(() => (
    <NoProjectsCheckbox text={t('teams.modal.without_projects')} disable={isSendWithoutProject} onClick={onSendWithoutProjects} />
  ), [onSendWithoutProjects, t, isSendWithoutProject ])

  const disableSend = useMemo(
  () => (isAllowParticipants ? (!isSendWithoutProject && selectedProjects?.length === 0) : selectedProjects?.length === 0)
  , [isSendWithoutProject, selectedProjects, isAllowParticipants])

  if (!profile) {
    return <NeedLogin competition={ competition }/>
  }

  return (

    <ModalContainer style={{ overflow: 'auto', height: '100%'}} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      
        <SendProjectModalWrapper directionMobile='column' justify={isMobile ? 'flex-start': 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative'}}>
            <ActionsWrapper hide={showWithoutProjectsModal} direction="column" style={{ justifyContent: 'center', position: 'relative', width: '100%' }}>
                <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' width={'100%'} >
                  <FlexBox direction='column' directionMobile='column'>
                    {!haveProjects && <MainTitle>
                      {isPaidApplication ? t('competition.pay_title') : t('competition.select_project')}
                    </MainTitle>}
                    {isMobile && isAllowParticipants && noProjectsRequestCheckbox}
                  </FlexBox>
                  {!isNewMobile && !haveProjects && !isPaidApplication && (
                    <FlexBox>
                      <SendButton isGreen={isGeo} width={187} disabled={disableSend} onClick={(isSendWithoutProject && selectedProjects?.length === 0) ? () => handleSendWihoutProject() : () => getLegalsModal(isNeedToFill, onApplyClick)}>
                        {t('competition.send')}
                      </SendButton>
                    </FlexBox>
                  )}
                  {isPaidApplication && userPaidCard && (
                    <FlexBox>
                      <SendButton isGreen={isGeo} width={187} disabled={disableSend} onClick={(isSendWithoutProject && selectedProjects?.length === 0) ? () => handleSendWihoutProject() : () => getLegalsModal(isNeedToFill, onApplyClick)}>
                        {t('competition.send')}
                      </SendButton>
                    </FlexBox>
                  )}
                </ActionsTitle>
                {(!haveProjects || isAllowParticipants) && (
                  <FlexBox offsetBottom={20} direction='row' justify='space-between' align='center'>
                    {showNoProjectsRequestCheckbox ? noProjectsRequestCheckbox : (
                      <ProjectsCount>
                          {t('competition.selected_projects', {count: selectedProjects?.length})}
                      </ProjectsCount>
                    )}
                    {
                    isMobile ? 
                    (
                      <MobileFilterSort onClick={onMobileSortingClick}>
                        <SortIcon/>
                        {/* Sort */}
                        <SortingType>{sorting === 1? t('sorting_type.latest') : t('sorting_type.popular')}</SortingType>
                      </MobileFilterSort>
                    ) : 
                    searchBar}
                  </FlexBox>
                )}
                {haveProjects && competition && <NeedProject competition={competition} />}
                {filterOpt && (
                   <ProjectsGridNew k={undefined} isLoading={false}>
                   {projects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                       return (
                          // @ts-ignore
                         <ProjectCardNew
                           project={v as any}
                           isModal={false}
                           withoutGoToProject={true}
                           onProjectClick={modal ?
                             (projectId?: string, e?: any) => {
                               e?.stopPropagation();
                               e?.preventDefault();
                             } : undefined}
                            isSelectable={true}
                           //@ts-ignore
                           isRejected={ProjectDelegate.isRejectedProject(v)}
                           key={(v?.projectId || '') + index}
                           {...computeProject(v)}
                          // isSelectRightNeed={isMobile}
                           metaAlwaysVisible
                           selectRingPosition={RingPositions.right}
                           onSelect={projectId => {
                            setSelectedProjects((prev: string[]) => {
                                if (isExam) return [projectId]
                                if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
                                return [...prev, projectId];
                            });
                            }}
                           selected={selectedProjects?.includes(v?.projectId ?? '')}
                           alreadyProject={isAlreadyProject(v?.projectId)}
                         />
                       );

                   })}
                 </ProjectsGridNew>
                )}
              {isNewMobile && (
                <ActionBottomButtons>
                  <SendButton width={ isNewMobile ? 112 : 187} disabled={selectedProjects?.length === 0} onClick={() => getLegalsModal(isNeedToFill, onApplyClick)}>
                    {t('competition.send')}
                  </SendButton>
                </ActionBottomButtons>
              )}
              {/* Футер с кнопками для экзаменов (lmsModuleProjectId) - показывается только при выборе проекта */}
              {isPaidApplication && !userPaidCard && !isNewMobile && selectedProjects.length > 0 && (
                <ExamFooterButtons>
                  <SelectedProjectWrapper gx={24} justify="space-between" align="center" width="100%">
                    <FlexBox gy={4} direction='column'>
                      <SelectedProjectName>
                        {selectedProjectName} выбран
                      </SelectedProjectName>
                      <SelectedProjectDesc>
                        Вы можете отправить только один проект
                      </SelectedProjectDesc>
                    </FlexBox>
                    <FlexBox gx={24}>
                      <DeselectButton onClick={handleDeselectProject}>Снять выбор</DeselectButton>
                      <SubmitButton onClick={handleSubmitFor}>Отправить</SubmitButton>
                    </FlexBox>
                  </SelectedProjectWrapper>
                </ExamFooterButtons>
              )}
            </ActionsWrapper>
            {showWithoutProjectsModal && <CompleteSend isCompetition title={competition?.name || ''} contextName={''} withoutProjects={true} />}
        </SendProjectModalWrapper>
    </ModalContainer>
  );
};
